import React from "react";
import { Label } from "~/components/ui/label";
import { Textarea } from "~/components/ui/textarea";
import { FieldComponentProps, isFieldApi } from "~/lib/form";
import { cn } from "~/shared/lib/utils";

interface ValidatedTextareaProps extends FieldComponentProps {
  description?: string;
  rows?: number;
  maxLength?: number;
  disabled?: boolean;
}

export const ValidatedTextarea: React.FC<ValidatedTextareaProps> = (props) => {
  const {
    field,
    label,
    placeholder,
    className,
    description,
    rows = 3,
    maxLength,
    disabled,
    ...rest
  } = props;

  const inputId = `${field.name}-${React.useId()}-textarea`;

  if (!isFieldApi(field)) {
    return null;
  }

  const meta = field.state.meta;

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={inputId}>{label}</Label>
      <Textarea
        id={inputId}
        name={field.name}
        value={String(field.state.value ?? "")}
        onBlur={field.handleBlur}
        onChange={(event) => field.handleChange(event.target.value)}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        disabled={field.form.state.isSubmitting || disabled}
        aria-invalid={!!meta.errors.length}
        aria-describedby={meta.errors.length ? `${inputId}-errors` : undefined}
        {...rest}
      />
      {description ? (
        <p className="text-muted-foreground text-sm">{description}</p>
      ) : null}
      {meta.isTouched && meta.errors.length > 0 ? (
        <div
          id={`${inputId}-errors`}
          role="alert"
          aria-live="polite"
          className="text-destructive text-sm font-medium"
        >
          {label}: {meta.errors.join(", ")}
        </div>
      ) : null}
    </div>
  );
};
